import { GKButton, GKModal, Grid2, SendIcon, Typography } from "components";
import { useSendProformaMutation } from "store/features/Revenue/ProformaApi";
import { numberToCurrency } from "utils/MathFunction";

interface Props {
  open: {
    open: boolean;
    type: string;
  };
  setOpen: (value: { open: boolean; type: string }) => void;
  proformaDetails: {
    id: string;
    date: string;
    proformaNumber: string;
    proformaPdf: string;
    feePlanName: string;
    remainingPaidAmount: number;
    totalFee: number;
    isInvoice: boolean;
    isForfeit: boolean;
    client: number;
    portfolio: number;
    clientName: string;
    clientCode: string;
    portfolioName: string;
    portfolioId: string;
    clientEmail: string;
  };
}

const ProformaSendModal = (props: Props) => {
  const { open, setOpen, proformaDetails } = props;

  const [sendProforma, { isLoading }] = useSendProformaMutation();

  return (
    <GKModal
      open={open?.open}
      setOpen={() => setOpen({ open: false, type: "" })}
      modalTitle={
        open?.type === "SEND_PROFORMA_ONLY"
          ? "Send Proforma Only"
          : "Send Proforma with Payment Link"
      }
      width={"500px"}
      footer={
        <GKButton
          variant="contained"
          startIcon={<SendIcon />}
          onClick={async () => {
            try {
              await sendProforma({
                id: proformaDetails?.id,
                type: open.type,
              }).unwrap();
              setOpen({ open: false, type: "" });
            } catch (err) {
              console.error("Send proforma failed:", err);
            }
          }}
          loading={isLoading}
        >
          Send Email
        </GKButton>
      }
    >
      <Grid2 container spacing={3}>
        <Grid2 size={12}>
          <Typography fontSize={12} fontWeight={500} color="var(--neutral-500)">
            Are you sure you want to send this proforma invoice to the client?
          </Typography>
        </Grid2>
        <Grid2 container size={12} spacing={1}>
          <Grid2 size={12}>
            <Typography
              fontSize={12}
              fontWeight={500}
              color="var(--neutral-500)"
              display={"flex"}
              alignItems={"center"}
              gap={1}
            >
              Recipient’s Name:{" "}
              <Typography
                color="var(--neutral-700)"
                fontSize={12}
                fontWeight={500}
              >
                {proformaDetails?.clientName}
              </Typography>
            </Typography>
          </Grid2>
          <Grid2 size={12}>
            <Typography
              fontSize={12}
              fontWeight={500}
              color="var(--neutral-500)"
              display={"flex"}
              alignItems={"center"}
              gap={1}
            >
              Recipient’s Email ID:
              <Typography
                color="var(--neutral-700)"
                fontSize={12}
                fontWeight={500}
              >
                {proformaDetails?.clientEmail || "-"}
              </Typography>
            </Typography>
          </Grid2>
          <Grid2 size={12}>
            <Typography
              fontSize={12}
              fontWeight={500}
              color="var(--neutral-500)"
              display={"flex"}
              alignItems={"center"}
              gap={1}
            >
              Amount:
              <Typography
                color="var(--neutral-700)"
                fontSize={12}
                fontWeight={500}
              >
                {numberToCurrency(proformaDetails?.totalFee)}{" "}
              </Typography>
            </Typography>
          </Grid2>
          <Grid2 size={12}>
            <Typography
              fontSize={12}
              fontWeight={500}
              color="var(--neutral-500)"
              display={"flex"}
              alignItems={"center"}
              gap={1}
            >
              Proforma Invoice No:
              <Typography
                color="var(--neutral-700)"
                fontSize={12}
                fontWeight={500}
              >
                {proformaDetails?.proformaNumber}
              </Typography>
            </Typography>
          </Grid2>
        </Grid2>
      </Grid2>
    </GKModal>
  );
};

export default ProformaSendModal;
